import request from '@/utils/requests.js'

// Exam API Services
export const examService = {
  // Exam Management
  async createExam(examData) {
    return request({
      url: '/exams/',
      method: 'post',
      data: examData
    })
  },

  async listExams(params = {}) {
    return request({
      url: '/exams/',
      method: 'get',
      params
    })
  },

  async getExamById(examId) {
    return request({
      url: `/exams/${examId}`,
      method: 'get'
    })
  },

  async updateExam(examId, examData) {
    return request({
      url: `/exams/${examId}`,
      method: 'put',
      data: examData
    })
  },

  async deleteExam(examId) {
    return request({
      url: `/exams/${examId}`,
      method: 'delete'
    })
  },

  async searchExams(searchTerm, filters = {}) {
    const params = { q: searchTerm, ...filters };
    return request({
      url: '/exams/search',
      method: 'get',
      params
    })
  },

  async getExamsByPatient(patientId) {
    return request({
      url: `/exams/patient/${patientId}`,
      method: 'get'
    })
  },

  // Reports
  async getExamReports(params = {}) {
    return request({
      url: '/exams/reports',
      method: 'get',
      params
    })
  },

  // Orthanc Sync
  async syncOrthancExams(limit = 100) {
    return request({
      url: `/orthanc-sync/sync-all?limit=${limit}`,
      method: 'post'
    })
  }
}
